// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* animated-counter.component.scss */
.counter {
  display: inline-flex;
  background: rgba(255, 255, 255, 0);
  padding: 5px;
  border-radius: 6px;
  gap: 0px;
}

.digit {
  font-size: 20px;
  font-family: monospace;
  font-weight: bold;
  line-height: 1em;
  height: 1em;
  width: 1.1ch;
  text-align: center;
  overflow: hidden;
  color: transparent;
  text-shadow: 0 0 0 #000;
  animation: spin 1.2s ease-out forwards;
}

@keyframes spin {
  100% {
    text-shadow: 0 var(--t) 0 var(--ion-color-primary);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/animated-counter/animated-counter.component.scss"],"names":[],"mappings":"AAAA,oCAAA;AACA;EACE,oBAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sCAAA;AACF;;AAEA;EACE;IACE,kDAAA;EACF;AACF","sourcesContent":["/* animated-counter.component.scss */\n.counter {\n  display: inline-flex;\n  background: #fff0;\n  padding: 5px;\n  border-radius: 6px;\n  gap: 0px;\n}\n\n.digit {\n  font-size: 20px;\n  font-family: monospace;\n  font-weight: bold;\n  line-height: 1em;\n  height: 1em;\n  width: 1.1ch;\n  text-align: center;\n  overflow: hidden;\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n  animation: spin 1.2s ease-out forwards;\n}\n\n@keyframes spin {\n  100% {\n    text-shadow: 0 var(--t) 0 var(--ion-color-primary);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
